const WaitForAllImagesToLoad = (onProgress) => {
  const images = Array.from(document.images);
  const total = images.length;

  if (total === 0) {
    onProgress(100);
    return Promise.resolve();
  }

  let loaded = 0;

  const handleProgress = () => {
    loaded += 1;
    const percent = Math.round((loaded / total) * 100);
    onProgress(percent);
  };

  const promises = images.map((img) => {
    if (img.complete) {
      handleProgress();
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      img.onload = img.onerror = () => {
        handleProgress();
        resolve();
      };
    });
  });

  return Promise.all(promises);
};

export default WaitForAllImagesToLoad;
